const URL = '/creditos';

const state = {
  selected: {
    id: null,
    cuenta_id: null,
    precio_id: null,
    fecha: null,
    periodo: null,
    glosa: null,
    importe: null,
    forma_pago_id: null,
    pagos: [],
    cambio: 0,
    recibo_id: null,
    recibo_numero: null,
    desglose_pagos: [],
  },
  edited: {
    id: null,
    cuenta_id: null,
    precio_id: null,
    fecha: null,
    periodo: null,
    glosa: null,
    importe: null,
    forma_pago_id: null,
    pagos: [],
    cambio: 0,
    recibo_id: null,
    recibo_numero: null,
    desglose_pagos: [],
  },
  loading: false,
  rules: {
    cuenta_id: [
      v => !!v || 'Este campo es necesario',
      v => v > 0 || 'Debe existir una cuenta asociada',
    ],
    precio_id: [
      v => !!v || 'Este campo es necesario',
      v => v > 0 || 'Debe existir un precio asociado',
    ],
    periodo: [
      v => !!v || 'Este campo es necesario',
    ],
    fecha: [
      v => !!v || 'Este campo es necesario',
    ],
    importe: [
      v => !!v || 'Este campo es necesario',
      v => v > 0 || 'Debe ser mayor a cero (0)',
    ],
    glosa: [
      // v => !!v || 'Este campo es necesario',
    ],
    forma_pago_id: [
      v => !!v || 'Este campo es necesario',
      v => v > 0 || 'Debe existir una forma de pago asociada',
    ],
  },
}

// GETTERS
const getters = {
  edited(state) {
    return state.edited
  },
  selected(state) {
    return state.selected
  },
  rules(state) {
    return state.rules
  },
  loading(state) {
    return state.loading
  },
  updatable(state) {
    return state.edited.id == state.selected.id && (
      state.edited.cuenta_id != state.selected.cuenta_id ||
      state.edited.precio_id != state.selected.precio_id ||
      state.edited.periodo != state.selected.periodo ||
      state.edited.fecha != state.selected.fecha ||
      state.edited.importe != state.selected.importe ||
      state.edited.saldo != state.selected.saldo ||
      state.edited.forma_pago_id != state.selected.forma_pago_id ||
      JSON.stringify(state.edited.pagos) !== JSON.stringify(state.selected.pagos)
    )
  },
}

// ACTIONS
const actions = {
  onClearEdited({ commit }) {
    commit('setEdited', {
      id: null,
      cuenta_id: null,
      precio_id: null,
      fecha: null,
      periodo: null,
      glosa: null,
      importe: null,
      forma_pago_id: null,
      pagos: [],
      cambio: 0,
      recibo_id: null,
      recibo_numero: null,
      desglose_pagos: [],
    })
  },
  onClearSelected({ commit }) {
    commit('setSelected', {
      id: null,
      cuenta_id: null,
      precio_id: null,
      fecha: null,
      periodo: null,
      glosa: null,
      importe: null,
      forma_pago_id: null,
      pagos: [],
      cambio: 0,
      recibo_id: null,
      recibo_numero: null,
      desglose_pagos: [],
    })
  },
  onSave({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      axios.post(URL, state.edited)
        .then(response => {
          const aux = {
            id: response.data.data.id,
            cuenta_id: response.data.data.cuenta_id,
            precio_id: response.data.data.precio_id,
            periodo: response.data.data.periodo,
            fecha: response.data.data.fecha,
            importe: response.data.data.importe,
            glosa: response.data.data.glosa,
            forma_pago_id: response.data.data.forma_pago_id,
            cambio: response.data.data.cambio,
            recibo_id: response.data.data.recibo_id,
            recibo_numero: response.data.data.recibo_numero,
            desglose_pagos: response.data.data.desglose_pagos || [],
          }
          commit('setSelected', aux)
          commit('ResponseHTTP/addSuccess', 'El credito fue registrado.', { root: true })
          resolve(response.data)
        })
        .catch(error => {
          commit('ResponseHTTP/addError', 'Error. No se registro el credito', { root: true })
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
}

// MUTATIONS
const mutations = {
  setEdited(state, payload) {
    state.edited = Object.assign({}, payload)
  },
  setSelected(state, payload) {
    state.selected = Object.assign({}, payload)
  },
  setLoading(state, payload) {
    state.loading = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
